var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVehicle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_360_20512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.59998 15.3167V6.84341C3.59998 4.5602 3.59998 3.4186 4.30292 2.7093C5.00587 2 6.13724 2 8.39998 2H11.6C13.8627 2 14.9941 2 15.697 2.7093C16.4 3.4186 16.4 4.5602 16.4 6.84341V15.3167C16.4 16.526 16.4 17.1307 16.0304 17.3687C15.4265 17.7577 14.4929 16.9419 14.0233 16.6459C13.6353 16.4011 13.4413 16.2788 13.226 16.2718C12.9933 16.2641 12.7959 16.3815 12.3767 16.6459L10.848 17.6099C10.4356 17.8699 10.2294 18 9.99998 18C9.77054 18 9.56438 17.8699 9.15198 17.6099L7.62329 16.6459C7.2353 16.4011 7.04131 16.2788 6.826 16.2718C6.59336 16.2641 6.39592 16.3815 5.97667 16.6459C5.50714 16.9419 4.57347 17.7577 3.96954 17.3687C3.59998 17.1307 3.59998 16.526 3.59998 15.3167Z",
    stroke: "#3469E7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.19993 9.19995H6.79993",
    stroke: "#3469E7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5999 6H6.79993",
    stroke: "#3469E7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_360_20512"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle);
export default __webpack_public_path__ + "static/media/vehicle.1ac162aceb0eebccfe7edb2c70a9b645.svg";
export { ForwardRef as ReactComponent };